<script>
    import {PRODUCT_TYPE} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import PriceControl from "../components/controls/PriceControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import Editor from "../components/Editor.svelte";
    import Alert from "../stores/alerts";

    export let productId = null;
    export let closeCallback;

    let product = null;
    let fileInput;
    let imageObj = null;

    const initialize = () => {
        if (productId == 0) {
            product = {
                type: '0',
                name: '',
                description: '',
                content: '',
                min_quantity: null,
                max_quantity: null,
                weight: null,
                price: null,
                no_vat: 0,
                image: '',
                requires_account: 1,
                requires_subscription: 0,
                is_active: 1
            }
            setFocusTo('productName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            product = result;
            if (product.weight == 0) {
                product.weight = null;
            }
            setFocusTo('productName');
        };

        const onFailure = err => {
        };

        R.handle(R.product.details, productId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Το προϊόν ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
            }
        };


        product.name = product.name.trim();
        if (!product.name) {
            Notifier.showError("Πληκτρολογήστε το όνομα του προϊόντος");
            setFocusTo("productName");
            return;
        }
        if (!product.price) {
            Notifier.showError("Πληκτρολογήστε μια τιμή για το προϊόν");
            setFocusTo("productPrice");
            return;
        }

        if (product.type == PRODUCT_TYPE.SERVICE) {
            product.weight = 0;
        }

        let action = productId == 0 ? 'create' : 'edit';
        R.handle(R.product[action], product, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        product = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }


    const onContentChange = ({detail}) => {
        product.content = detail.text;
    }

    /* Image handlers */

    const onRemoveImage = () => {
        Alert.delete("Διαγραφή εικόνας", "Να αφαιρεθεί η εικόνα από το προϊόν;", () => {
            product.image = '';
            product.new_image = '';
        });
    }

    const onFileSelected = event => {
        imageObj = event.target.files[0];
        uploadImage();
    }

    const uploadImage = () => {
        const onSuccess = result => {
            product.new_image = result.filename;
            // field.icon = result;
            // iconObj = null;
            // close(field);
        }

        const onFailure = err => {
            let message = 'Παρουσιάστηκε σφάλμα κατά την μεταφόρτωση της εικόνας!';
            if (err.code) {
                message = err.message;
                if (err.params) {
                    message += `\nΌνομα αρχείου: ${err.params}`;
                }
            }
            Alert.warning("Μεταφόρτωση εικόνας", message);
        };

        let data = {
            product_id: product.id,
        }

        R.handle(R.product.uploadImage, {data, image: imageObj}, onSuccess, onFailure, LOADER.POPUP);
    }


    initialize();

    $:{
        if (product != null && !product.requires_account) {
            product.requires_subscription = 0;
        }
    }
</script>

{#if product}
    <Modal title="Προϊόν" modalMd on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Είδος</label>
                <select class="form-select" bind:value="{ product.type }">
                    <option value="0">Προϊόν</option>
                    <option value="1">Υπηρεσία</option>
                </select>
            </div>
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="productName" bind:value="{ product.name }">
            </div>
            <div class="form-group">
                <label>Περιγραφή</label>
                <textarea class="form-control" bind:value="{ product.description }"></textarea>
            </div>
            <div class="form-group">
                <Editor id="content" text="{ product.content }" on:change={ onContentChange }/>
            </div>
            <hr>
            <div class="row">
                <div class="col-xl-6">
                    <div class="row">
                        <h6>Τεμάχια</h6>
                        <div class="col-6 form-group">
                            <label>Ελάχιστα</label>
                            <input type="number" class="form-control" bind:value="{ product.min_quantity }"
                                   placeholder="χωρίς όριο">
                        </div>
                        <div class="col-6 form-group">
                            <label>Μέγιστα</label>
                            <input type="number" class="form-control" bind:value="{ product.max_quantity }"
                                   placeholder="χωρίς όριο">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-group">
                            <label>Τιμή</label>
                            <PriceControl id="productPrice" bind:value={ product.price }/>
                        </div>
                        <div class="col-6">
                            {#if product.type == PRODUCT_TYPE.PRODUCT}
                                <div class="form-group">
                                    <label>Βάρος (γραμμάρια)</label>
                                    <input type="text" class="form-control" bind:value="{ product.weight }">
                                </div>
                            {/if}
                        </div>
                    </div>
                    <Checkbox label="χωρίς Φ.Π.Α. στην τιμή πώλησης" bind:checked={ product.no_vat }/>
                    <hr>
                    <div class="form-group">
                        <Checkbox label="Απαιτείται λογαριασμός" bind:checked={ product.requires_account } disabled/>
                    </div>
                    <div class="form-group">
                        <Checkbox label="Απαιτείται τακτοποιημένη συνδρομή"
                                  bind:checked={ product.requires_subscription }
                                  disabled="{ !product.requires_account }"/>
                    </div>
                    <div class="form-group">
                        <Checkbox label="Ενεργό προϊόν" bind:checked={ product.is_active }/>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="product-image mb-1">
                        {#if product.new_image}
                            <img src="/img/upload/{ product.new_image }" alt="product image">
                        {:else if product.image}
                            <img src="/img/products/{ product.image }" alt="product image">
                        {/if}
                        <div class="tip">διαστάσεις 500x500 pixels</div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <button class="btn btn-default btn-block" on:click="{ () => { fileInput.click() } }">
                                Εύρεση
                            </button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-default btn-block"
                                    disabled="{ !product.image && !product.new_image }" on:click={ onRemoveImage }>
                                Διαγραφή
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>

            <input style="display:none" type="file" accept=".jpg, .jpeg, .png, .svg"
                   on:change={ (event) => onFileSelected(event) }
                   bind:this={ fileInput }>
        </div>
    </Modal>
{/if}

<style>
    .product-image {
        position: relative;
        background: #ccc;
        height: 230px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .product-image img {
        height: 100%;
        width: auto;
    }

    .product-image .tip {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0 2px;
        color: #fff;
        background: rgba(0, 0, 0, 0.8);
    }
</style>